module.exports = __webpack_public_path__ + "img/spoken_origin1_effect .0df6d6a8.svg";